// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.integration-page {
  font-family: "DM Sans", sans-serif;
  margin: 20px;
  margin-top: 0;
}

.bot-select-item.Mui-selected {
  background-color: #5616ea !important;
  color: white !important;
}

.bot-select-item.Mui-selected:hover {
  background-color: #4a14d6 !important;
}

.bot-select-item:hover {
  background-color: #e0f7fa;
}

.tabs {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 2px solid #ddd;
  max-width: 800px;
  overflow-x: auto;
  overflow-y: hidden;
}

.tabs::-webkit-scrollbar {
  display: none;
}

.tab {
  flex: 1 1;
  padding: 12px;
  padding-bottom: 16px;
  text-align: center;
  cursor: pointer;
  font-size: 17px !important;
  background-color: transparent;
  border: none;
  position: relative;
  outline: none;
  min-width: -moz-fit-content;
  min-width: fit-content;
  flex-shrink: 0;
}

.tab::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 4.5px;
  background-color: #5616ea;
  transition: width 0.4s ease;
}

.tab:hover::after,
.tab.active::after {
  width: 100%;
}

.tab.active {
  font-weight: bold;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.tab-with-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  position: relative;
}

.tab .tab-badge {
  position: static;
  background-color: #5616ea;
  color: #fff;
  border-radius: 8px;
  padding: 5px;
  padding-bottom: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.integration-tab-content {
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  gap: 15px;
  max-width: 800px;
}

/* ── Snippet sub-tabs (Widget / Iframe) ── */
/* These now reuse the Activity-Inbox \`.platform-filter\` chips (animated
   draw-around border); this only adds the spacing below the row. */
.snippet-mode-filters {
  margin-bottom: 12px;
  margin-top: 2px !important;
}

.snippet-mode-tabs {
  display: flex;
  padding: 6px;
  padding-top: 2px;
  padding-bottom: 6px;
  border-radius: 8px;
  gap: 10px;
  overflow: visible;
  max-width: 800px;
  margin-bottom: 12px;
}

.snippet-mode-tabs::-webkit-scrollbar {
  display: none;
}

.snippet-mode-tab {
  all: unset;
  position: relative;
  cursor: pointer;
  font-size: 16px;
  padding: 8px 10px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #353b43;
  transition: background 0.2s, color 0.2s, font-weight 0.2s;
  box-shadow: 0 0 0 1px #e3e4e7;
  flex-shrink: 0;
  white-space: nowrap;
}

.snippet-mode-tab:hover {
  background: #e5e7eb;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
}

.snippet-mode-tab.active {
  background: #ffffff;
  color: #111827;
  box-shadow: 0 0 0 1px #e0e2e5;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
}

.snippet-mode-badge {
  position: absolute;
  top: -10px;
  right: -14px;
  background-color: #5616ea;
  color: #fff;
  border-radius: 8px;
  padding: 5px;
  padding-bottom: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: 1;
  pointer-events: none;
}

/* ── Info box ──────────────────────────────────────────────────────────
   Shares one visual language with \`.cguide-intro\` in ChannelGuide.css, so
   every Deploy → Channels modal reads the same whether it renders a guide
   (Website widget / iframe) or an Integration tab (Chat link, Wix, Webflow,
   WordPress). Keep the two in sync: tint #f4efff, 1px #e4d9ff hairline,
   4px purple rail, 10px radius, 14px/1.55 body. */
.integration-info-box {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 14px;
  background-color: #f4efff;
  border: 1px solid #e4d9ff;
  border-left: 4px solid #5616ea;
  border-radius: 10px;
  padding: 14px 16px;
  line-height: 1.55;
}

.integration-info-icon {
  font-size: 19px;
  color: #5616ea;
  flex-shrink: 0;
}

.integration-info-text {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}

.integration-info-box p {
    margin: 0 !important;
    padding: 0;
  }

/* Two classes deep so it outranks the generic \`.integration-tab-content p\`
   16px rule further down this file. */
.integration-info-box .integration-info-text p {
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.55;
  color: #3a3a45;
}

.integration-info-text ul {
  margin: 8px 0 0;
  padding-left: 2px;
  list-style: none;
}

.integration-info-text li {
  position: relative;
  padding-left: 16px;
  margin-top: 6px;
  font-size: 13.5px;
  line-height: 1.5;
  color: #565662;
}

/* Purple dot instead of a browser disc: same accent as the rail, and it sits
   on the first line's optical centre regardless of how the item wraps. */
.integration-info-text li::before {
  content: "";
  position: absolute;
  left: 2px;
  top: 8px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #5616ea;
}

.integration-info-text code {
  background-color: rgba(86, 22, 234, 0.09);
  color: #5616ea;
  padding: 1px 6px;
  border-radius: 5px;
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;
  font-size: 0.85em;
}

.integration-connect-text {
  margin: 0 !important;
}

.integration-connect-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 220px;
  width: -moz-fit-content;
  width: fit-content;
  align-self: flex-start;
}

.share-link-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.share-link-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}

.integration-tab-content p {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
}

.code-wrapper {
  position: relative;
}

.copy-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  background-color: transparent;
  padding: 6px 12px;
  font-size: 14px;
  border: none;
  outline: none;
  border-radius: 3px;
  cursor: pointer;
  transition: 0.2s ease, color 0.2s ease;
  color: #5616ea;
}

.copy-btn:hover {
  cursor: pointer;
  transform: translateY(-1px);
}

.code-container {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: auto;
  background-color: #f9f9f9;
  border: 2px solid #5616ea;
  border-radius: 5px;
  padding: 15px;
  padding-top: 50px;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
}

.code-container pre {
  margin: 0;
}

.code-container code {
  color: #2d2d2d;
  font-family: monospace;
  font-size: 14px;
}

.copy-button-content {
  display: flex;
  align-items: center;
  gap: 5px;
}

.arrow-down-container {
  display: flex;
  justify-content: center;
  margin: 0px;
  font-size: 36px;
  color: #5616ea;
}

.integration-help-box {
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  max-width: 800px;
  margin-top: 20px;
}

.integration-options {
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: left;
}

.integration-support-header-container {
  display: flex;
  font-size: 18px;
  align-items: center;
  gap: 10px;
}

.integratin-support-icon {
  font-size: 26px;
  color: #5616ea;
  margin-bottom: 2px;
}

.option-item {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
/* Moved here from helpPage.css (the help page no longer renders .option-item);
   integration.js and integrationModal.js still rely on it. */
.option-item p {
  font-size: 15px;
  color: #444;
  line-height: 1.5;
}

.integration-option-button {
  width: 100%;
  max-width: 300px;
  border: none;
  background-color: #5616ea;
  font-size: 18px;
  text-align: center;
  padding: 12px;
  padding-left: 14px;
  padding-right: 14px;
  border-radius: 10px;
  color: white;
  transition: 0.2s ease, color 0.2s ease;
  cursor: pointer;
}

.integration-option-button:hover:not(:disabled) {
  background-color: #4a14d6;
  cursor: pointer;
  transform: translateY(-2px);
}

.integration-option-button:disabled {
  cursor: not-allowed;
  background-color: #c6c6c6;
  color: black;
}

.integratin-button-icon {
  margin-right: 8px;
}

.integration-loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.integration-spinner {
  border: 7px solid #f3f3f3;
  border-top: 7px solid #5616ea;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.1s linear infinite;
  margin: 20px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.wix-status-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.wix-status-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
  margin: 0;
}

.wix-status-line {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom:  10px !important;
  margin-top: 15px !important;
}

.wix-icon {
  font-size: 18px;
}

.wix-icon.connected {
  color: #5616ea;
}

.wix-icon.live {
  color: #5616ea;
}

.wix-icon.not-live {
  color: #d32f2f;
}

.wix-url {
  color: #5616ea;
  font-weight: 600;
  text-decoration: none;
}

.wix-url:hover {
  text-decoration: underline;
}

.wix-status-chip {
  font-weight: 600;
  font-size: 14px;
  border-radius: 12px;
  padding: 2px 10px;
}

.chip-live {
  color: white;
  background-color: #5616ea;
}

.chip-not-live {
  color: #d32f2f;
  background-color: #fdecea;
}

/* Wix script on, but the site is built with its own code and never shows it (integration.js wixNotOnSite) */
.wix-icon.not-visible {
  color: #d97a1f;
}

.chip-not-visible {
  color: #9a4b00;
  background-color: #fff3e6;
}

.wix-own-code {
  margin-top: 10px;
}

.wix-own-code-text {
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.5;
  color: #444;
}

.change-wix-button-content {
  display: flex;
  align-items: center;
  gap: 5px;
}

.wix-icon-change {
  color: white;
  margin-bottom: 2px;
}

.control-group-no-gap {
  gap: 0 !important;
}

.select-website-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.select-website-container p {
  margin: 0;
  padding: 0;
  font-weight: 600;
}

.select-website-button-container {
  display: flex;
  gap: 10px;
}

.integration-status-checkmark {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}

.integration-status-checkmark p {
  margin: 0;
  padding: 0;
}

.integration-okay-status-icon {
  color: #5616ea;
  font-size: 22px;
}

.wordpress-tab-c {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 8px;
}

.wp-btn-c {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14.5px;
  font-weight: 600;
  padding: 10px 12px;
  border-radius: 7px;
  border: none;
  cursor: pointer;
  transition: background-color .2s ease, transform .12s ease;
  color: #fff;
}

.wp-btn-c.left {
  background: #5616ea;
}

.wp-btn-c.left:hover {
  background: #4a14d6;
  transform: translateY(-1px);
}

.wp-btn-c.right {
  background: #3a3a3a;
}

.wp-btn-c.right:hover {
  background: #2b2b2b;
  transform: translateY(-1px);
}

.create-here-button {
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  color: #005f8a;
  cursor: pointer;
  text-decoration: underline;
  font-size: 18px;
  font-weight: 600;
}

.bots-overview-header h1 {
  margin: 0;
  padding: 0;
}

@media (max-width: 768px) {
  .tabs {
    width: 100%;
    max-width: 100%;
  }

  .tab {
    color: rgb(34, 34, 34);
    padding: 15px;
    padding-top: 10px;
  }

  .integration-tab-content {
    padding: 20px;
  }

  .wordpress-tab-c {
    grid-template-columns: 1fr;
  }

  .copy-btn:hover {
    cursor: pointer;
    transform: translateY(0px);
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/integration.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,2BAAsB;EAAtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;mEACmE;AACnE;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,yDAAyD;EACzD,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;;;kDAKkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;;AAEA;IACI,oBAAoB;IACpB,UAAU;EACZ;;AAEF;sCACsC;AACtC;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;yEACyE;AACzE;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wEAAwE;EACxE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,qCAAqC;AACvC;AACA;6DAC6D;AAC7D;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,4GAA4G;AAC5G;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,0DAA0D;EAC1D,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,UAAU;EACV,SAAS;EACT,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,0BAA0B;EAC5B;AACF","sourcesContent":[".integration-page {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  margin: 20px;\r\n  margin-top: 0;\r\n}\r\n\r\n.bot-select-item.Mui-selected {\r\n  background-color: #5616ea !important;\r\n  color: white !important;\r\n}\r\n\r\n.bot-select-item.Mui-selected:hover {\r\n  background-color: #4a14d6 !important;\r\n}\r\n\r\n.bot-select-item:hover {\r\n  background-color: #e0f7fa;\r\n}\r\n\r\n.tabs {\r\n  display: flex;\r\n  margin-bottom: 30px;\r\n  border-bottom: 2px solid #ddd;\r\n  max-width: 800px;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n}\r\n\r\n.tabs::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.tab {\r\n  flex: 1;\r\n  padding: 12px;\r\n  padding-bottom: 16px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  font-size: 17px !important;\r\n  background-color: transparent;\r\n  border: none;\r\n  position: relative;\r\n  outline: none;\r\n  min-width: fit-content;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.tab::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -2px;\r\n  left: 0;\r\n  width: 0;\r\n  height: 4.5px;\r\n  background-color: #5616ea;\r\n  transition: width 0.4s ease;\r\n}\r\n\r\n.tab:hover::after,\r\n.tab.active::after {\r\n  width: 100%;\r\n}\r\n\r\n.tab.active {\r\n  font-weight: bold;\r\n  border-top-left-radius: 10px;\r\n  border-top-right-radius: 10px;\r\n}\r\n\r\n.tab-with-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  position: relative;\r\n}\r\n\r\n.tab .tab-badge {\r\n  position: static;\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  padding: 5px;\r\n  padding-bottom: 4px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.integration-tab-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 20px;\r\n  padding: 30px;\r\n  box-shadow: 0 10px 30px rgba(0,0,0,0.05);\r\n  gap: 15px;\r\n  max-width: 800px;\r\n}\r\n\r\n/* ── Snippet sub-tabs (Widget / Iframe) ── */\r\n/* These now reuse the Activity-Inbox `.platform-filter` chips (animated\r\n   draw-around border); this only adds the spacing below the row. */\r\n.snippet-mode-filters {\r\n  margin-bottom: 12px;\r\n  margin-top: 2px !important;\r\n}\r\n\r\n.snippet-mode-tabs {\r\n  display: flex;\r\n  padding: 6px;\r\n  padding-top: 2px;\r\n  padding-bottom: 6px;\r\n  border-radius: 8px;\r\n  gap: 10px;\r\n  overflow: visible;\r\n  max-width: 800px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.snippet-mode-tabs::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.snippet-mode-tab {\r\n  all: unset;\r\n  position: relative;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  padding: 8px 10px;\r\n  border-radius: 8px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  color: #353b43;\r\n  transition: background 0.2s, color 0.2s, font-weight 0.2s;\r\n  box-shadow: 0 0 0 1px #e3e4e7;\r\n  flex-shrink: 0;\r\n  white-space: nowrap;\r\n}\r\n\r\n.snippet-mode-tab:hover {\r\n  background: #e5e7eb;\r\n  transition: background 0.2s, color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.snippet-mode-tab.active {\r\n  background: #ffffff;\r\n  color: #111827;\r\n  box-shadow: 0 0 0 1px #e0e2e5;\r\n  transition: background 0.2s, color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.snippet-mode-badge {\r\n  position: absolute;\r\n  top: -10px;\r\n  right: -14px;\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  padding: 5px;\r\n  padding-bottom: 4px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  line-height: 1;\r\n  pointer-events: none;\r\n}\r\n\r\n/* ── Info box ──────────────────────────────────────────────────────────\r\n   Shares one visual language with `.cguide-intro` in ChannelGuide.css, so\r\n   every Deploy → Channels modal reads the same whether it renders a guide\r\n   (Website widget / iframe) or an Integration tab (Chat link, Wix, Webflow,\r\n   WordPress). Keep the two in sync: tint #f4efff, 1px #e4d9ff hairline,\r\n   4px purple rail, 10px radius, 14px/1.55 body. */\r\n.integration-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: row;\r\n  gap: 14px;\r\n  background-color: #f4efff;\r\n  border: 1px solid #e4d9ff;\r\n  border-left: 4px solid #5616ea;\r\n  border-radius: 10px;\r\n  padding: 14px 16px;\r\n  line-height: 1.55;\r\n}\r\n\r\n.integration-info-icon {\r\n  font-size: 19px;\r\n  color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.integration-info-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.integration-info-box p {\r\n    margin: 0 !important;\r\n    padding: 0;\r\n  }\r\n\r\n/* Two classes deep so it outranks the generic `.integration-tab-content p`\r\n   16px rule further down this file. */\r\n.integration-info-box .integration-info-text p {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 14px;\r\n  line-height: 1.55;\r\n  color: #3a3a45;\r\n}\r\n\r\n.integration-info-text ul {\r\n  margin: 8px 0 0;\r\n  padding-left: 2px;\r\n  list-style: none;\r\n}\r\n\r\n.integration-info-text li {\r\n  position: relative;\r\n  padding-left: 16px;\r\n  margin-top: 6px;\r\n  font-size: 13.5px;\r\n  line-height: 1.5;\r\n  color: #565662;\r\n}\r\n\r\n/* Purple dot instead of a browser disc: same accent as the rail, and it sits\r\n   on the first line's optical centre regardless of how the item wraps. */\r\n.integration-info-text li::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 2px;\r\n  top: 8px;\r\n  width: 5px;\r\n  height: 5px;\r\n  border-radius: 50%;\r\n  background: #5616ea;\r\n}\r\n\r\n.integration-info-text code {\r\n  background-color: rgba(86, 22, 234, 0.09);\r\n  color: #5616ea;\r\n  padding: 1px 6px;\r\n  border-radius: 5px;\r\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;\r\n  font-size: 0.85em;\r\n}\r\n\r\n.integration-connect-text {\r\n  margin: 0 !important;\r\n}\r\n\r\n.integration-connect-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  max-width: 220px;\r\n  width: fit-content;\r\n  align-self: flex-start;\r\n}\r\n\r\n.share-link-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.share-link-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.integration-tab-content p {\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.code-wrapper {\r\n  position: relative;\r\n}\r\n\r\n.copy-btn {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  z-index: 2;\r\n  background-color: transparent;\r\n  padding: 6px 12px;\r\n  font-size: 14px;\r\n  border: none;\r\n  outline: none;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n  transition: 0.2s ease, color 0.2s ease;\r\n  color: #5616ea;\r\n}\r\n\r\n.copy-btn:hover {\r\n  cursor: pointer;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.code-container {\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n  overflow-x: auto;\r\n  background-color: #f9f9f9;\r\n  border: 2px solid #5616ea;\r\n  border-radius: 5px;\r\n  padding: 15px;\r\n  padding-top: 50px;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n  line-height: 1.6;\r\n}\r\n\r\n.code-container pre {\r\n  margin: 0;\r\n}\r\n\r\n.code-container code {\r\n  color: #2d2d2d;\r\n  font-family: monospace;\r\n  font-size: 14px;\r\n}\r\n\r\n.copy-button-content {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.arrow-down-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 0px;\r\n  font-size: 36px;\r\n  color: #5616ea;\r\n}\r\n\r\n.integration-help-box {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 20px;\r\n  padding: 30px;\r\n  box-shadow: 0 10px 30px rgba(0,0,0,0.05);\r\n  max-width: 800px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.integration-options {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  text-align: left;\r\n}\r\n\r\n.integration-support-header-container {\r\n  display: flex;\r\n  font-size: 18px;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.integratin-support-icon {\r\n  font-size: 26px;\r\n  color: #5616ea;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.option-item {\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 15px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n/* Moved here from helpPage.css (the help page no longer renders .option-item);\r\n   integration.js and integrationModal.js still rely on it. */\r\n.option-item p {\r\n  font-size: 15px;\r\n  color: #444;\r\n  line-height: 1.5;\r\n}\r\n\r\n.integration-option-button {\r\n  width: 100%;\r\n  max-width: 300px;\r\n  border: none;\r\n  background-color: #5616ea;\r\n  font-size: 18px;\r\n  text-align: center;\r\n  padding: 12px;\r\n  padding-left: 14px;\r\n  padding-right: 14px;\r\n  border-radius: 10px;\r\n  color: white;\r\n  transition: 0.2s ease, color 0.2s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n.integration-option-button:hover:not(:disabled) {\r\n  background-color: #4a14d6;\r\n  cursor: pointer;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.integration-option-button:disabled {\r\n  cursor: not-allowed;\r\n  background-color: #c6c6c6;\r\n  color: black;\r\n}\r\n\r\n.integratin-button-icon {\r\n  margin-right: 8px;\r\n}\r\n\r\n.integration-loading-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 200px;\r\n}\r\n\r\n.integration-spinner {\r\n  border: 7px solid #f3f3f3;\r\n  border-top: 7px solid #5616ea;\r\n  border-radius: 50%;\r\n  width: 60px;\r\n  height: 60px;\r\n  animation: spin 1.1s linear infinite;\r\n  margin: 20px;\r\n}\r\n\r\n@keyframes spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.wix-status-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.wix-status-title {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #1a1a1a;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  padding-bottom: 10px;\r\n  margin: 0;\r\n}\r\n\r\n.wix-status-line {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #333;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  margin-bottom:  10px !important;\r\n  margin-top: 15px !important;\r\n}\r\n\r\n.wix-icon {\r\n  font-size: 18px;\r\n}\r\n\r\n.wix-icon.connected {\r\n  color: #5616ea;\r\n}\r\n\r\n.wix-icon.live {\r\n  color: #5616ea;\r\n}\r\n\r\n.wix-icon.not-live {\r\n  color: #d32f2f;\r\n}\r\n\r\n.wix-url {\r\n  color: #5616ea;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n}\r\n\r\n.wix-url:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.wix-status-chip {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  border-radius: 12px;\r\n  padding: 2px 10px;\r\n}\r\n\r\n.chip-live {\r\n  color: white;\r\n  background-color: #5616ea;\r\n}\r\n\r\n.chip-not-live {\r\n  color: #d32f2f;\r\n  background-color: #fdecea;\r\n}\r\n\r\n/* Wix script on, but the site is built with its own code and never shows it (integration.js wixNotOnSite) */\r\n.wix-icon.not-visible {\r\n  color: #d97a1f;\r\n}\r\n\r\n.chip-not-visible {\r\n  color: #9a4b00;\r\n  background-color: #fff3e6;\r\n}\r\n\r\n.wix-own-code {\r\n  margin-top: 10px;\r\n}\r\n\r\n.wix-own-code-text {\r\n  margin: 0 0 10px;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: #444;\r\n}\r\n\r\n.change-wix-button-content {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.wix-icon-change {\r\n  color: white;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.control-group-no-gap {\r\n  gap: 0 !important;\r\n}\r\n\r\n.select-website-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.select-website-container p {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.select-website-button-container {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.integration-status-checkmark {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.integration-status-checkmark p {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.integration-okay-status-icon {\r\n  color: #5616ea;\r\n  font-size: 22px;\r\n}\r\n\r\n.wordpress-tab-c {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.wp-btn-c {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  font-size: 14.5px;\r\n  font-weight: 600;\r\n  padding: 10px 12px;\r\n  border-radius: 7px;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background-color .2s ease, transform .12s ease;\r\n  color: #fff;\r\n}\r\n\r\n.wp-btn-c.left {\r\n  background: #5616ea;\r\n}\r\n\r\n.wp-btn-c.left:hover {\r\n  background: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.wp-btn-c.right {\r\n  background: #3a3a3a;\r\n}\r\n\r\n.wp-btn-c.right:hover {\r\n  background: #2b2b2b;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.create-here-button {\r\n  background-color: transparent;\r\n  border: none;\r\n  outline: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  color: #005f8a;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.bots-overview-header h1 {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .tabs {\r\n    width: 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .tab {\r\n    color: rgb(34, 34, 34);\r\n    padding: 15px;\r\n    padding-top: 10px;\r\n  }\r\n\r\n  .integration-tab-content {\r\n    padding: 20px;\r\n  }\r\n\r\n  .wordpress-tab-c {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .copy-btn:hover {\r\n    cursor: pointer;\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
